module.exports = __webpack_public_path__ + "static/img/2_7_1.b248fb5b.jpg";